/**
 * shareOrCopyLink — tries the Web Share API first, falls back to clipboard copy.
 *
 * @param {object} options
 * @param {string} options.url      - The URL to share/copy
 * @param {string} [options.title]  - Title passed to navigator.share
 * @param {string} [options.text]   - Body text passed to navigator.share
 * @param {Function} options.onCopied - Called after a successful clipboard write (fallback path)
 */
export const shareOrCopyLink = async ({url, title = '', text = '', onCopied}) => {
    if (typeof navigator === 'undefined') return

    if (navigator.share) {
        try {
            await navigator.share({title, text: url || text, url})
            return
        } catch (err) {
            // User dismissed the share sheet — no feedback needed
            if (err?.name === 'AbortError') return
            // Any other error: fall through to clipboard copy
        }
    }

    try {
        await navigator.clipboard.writeText(url)
        onCopied?.()
    } catch {
        // clipboard unavailable (non-secure context etc.) — fail silently
    }
}
